<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="2"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      v-if="!Bignav"
      :Type="false"
      :ImgUrl="'b01.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container.vue";
export default {
  name: "T07",
  data() {
    return {
      Bignav: false,
      Container: {
        subtitle: "",
        videosrc: "T07.mp4",
        title: "RapidArc Dynamic-個人化弧形治療的智慧新動向",
        list: [
          {
            title:'充分發揮計畫與投照的所有潛能',
            body: "RapidArc Dynamic 開啟新局面，讓臨床醫師能在數秒內快速產生治療計畫，同時降低危急器官的劑量。 本系統專為提升計畫品質、簡化複雜病例規劃及節省時間而設計，使臨床團隊能更有效率地提供更個人化的照護。\n" +
              "將新一代演算法與智慧型創新硬體整合為單一解決方案，旨在協助臨床醫師大幅提升作業效率，在更短的時間內完成計畫設計與治療執行。"
          },
          {
            body: [
              "在單一治療區域內的 IMRT 方向控制與 VMAT 投照效率",
              "VMAT、IMRT和動態準直儀，可於單一照野內調控做動",
              "治療過程中即時調整準直儀，確保投照最佳劑量",
              "透過調控照野自訂劑量分佈，對應適合的解剖結構",
              "支援 GPU 的新演算法，可快速生成治療計畫",
              "Auto-Skin-Flash工具，用於簡化和自動化多步驟流程",
              "整合 Eclipse 治療計畫系統內現有的自動化功能，包括ESAPI、MCO、RapidPlan、範本、臨床目標等"
            ]
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
